export const commaPrice = (price: number) =>
  new Intl.NumberFormat('ko-KR', { minimumFractionDigits: 0 }).format(price);
